import React, { useEffect, useState } from 'react';
import { Box, IconButton, Container, Menu, MenuItem, Typography } from '@mui/material';
import LogoImage from "../../assets/images/logo.png";
import Image from '../../components/Image';
import "./style.scss";
import Hamburger from 'hamburger-react';
import Link from '../Link';
import CenterBox from '../CenterBox';

export default function Navbar() {
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        window.addEventListener('scroll', () => {
            const isTop = window.scrollY > 100;
            const header = document.querySelector('.fixed-header');
            if (isTop) {
                header.classList.add('scrolled-header');
            } else {
                header.classList.remove('scrolled-header');
            }
        });
    }, []);

    return (
        <Box className="fixed-header">
            <Container className='navbar-container' disableGutters>
                <Image className="icon" href="/" src={LogoImage} />
                <CenterBox>
                    <Box className="nav-link-box">
                        <IconButton
                            id="basic-button"
                            className="menu-icon"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                        >
                            <Hamburger toggled={open} />
                        </IconButton >
                        <Box className="nav-link-box list-items">
                            <Link href="/"><Typography className="nav-link" variant="h6">Home</Typography></Link>
                            <Link href="https://app.orbpad.finance/presale" target="_blank"><Typography className="nav-link" variant="h6">Launchpad</Typography></Link>
                            <Link href="https://app.orbpad.finance/lock" target="_blank"><Typography className="nav-link" variant="h6">OrbPad Lock</Typography></Link>
                        </Box>
                    </Box>
                </CenterBox>
                <Menu
                    className="mobile-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={handleClose}><Link href="/" >Home</Link></MenuItem>
                    <MenuItem onClick={handleClose}><Link href="https://app.orbpad.finance/presale" target="_blank">Presale</Link></MenuItem>
                    <MenuItem onClick={handleClose}><Link href="https://app.orbpad.finance/lock" target="_blank">OrbPad Lock</Link></MenuItem>
                </Menu>
            </Container>
        </Box>
    )
}
